import { Component, Input } from '@angular/core';
import { Document } from '../documents.models';

@Component({
  standalone: false,
  selector: 'dsp-mobile-document-card',
  templateUrl: 'mobile-card.component.html',
  styleUrls: [ 'mobile-card.component.scss' ]
})
export class MobileCardComponent {
  @Input() public file: Document;
}
